import { render } from "./MinusCircle.vue?vue&type=template&id=1ae4c5c2"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/MinusCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ae4c5c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ae4c5c2', __exports__)) {
    api.reload('1ae4c5c2', __exports__)
  }
  
  module.hot.accept("./MinusCircle.vue?vue&type=template&id=1ae4c5c2", () => {
    api.rerender('1ae4c5c2', render)
  })

}


export default __exports__